// extracted by mini-css-extract-plugin
export var center = "styles-module--center--efc24";
export var prices = "styles-module--prices--0f3e9";
export var pricing = "styles-module--pricing--22bdb";
export var savings = "styles-module--savings--a9136";